// extracted by mini-css-extract-plugin
export default {"popoverBox":"Popup_popoverBox__fG2W9","popoverInnerBox":"Popup_popoverInnerBox__NigIc","popoverArrow":"Popup_popoverArrow__fu-TV","popover":"Popup_popover__UGd-N"};